export const yyyymmdd_ddmmyyy = yyyymmdd => {
  return yyyymmdd ? yyyymmdd.replace(/^(\d{4})-(\d{1,2})-(\d{1,2})$/, '$3/$2/$1') : ''
}

export const format = function date2str (x, y) {
  x = x instanceof Date ? x : new Date(x)
  var z = {
    M: x.getMonth() + 1,
    d: x.getDate(),
    h: x.getHours(),
    m: x.getMinutes(),
    s: x.getSeconds()
  }
  y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v) {
    return ((v.length > 1 ? '0' : '') + eval('z.' + v.slice(-1))).slice(-2)
  })

  return y.replace(/(y+)/g, function (v) {
    return x.getFullYear().toString().slice(-v.length)
  })
}

export const set = (key, cb = null) => (state, val) => {
  state[key] = cb && cb.constructor && cb.call && cb.apply ? cb(val) : val
}

export const search = (elems, search) => {
  const term = search && search.length >= 3 ? search.toLowerCase() : ''
  return term ? elems.filter(el => el && JSON.stringify(el).toLowerCase().includes(term)) : elems
}

export const clone = obj => JSON.parse(JSON.stringify(obj))

export const UID = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9)
}

export const padding0 = function (num, digit) {
  var zero = ''
  for (var i = 0; i < digit; i++) {
    zero += '0'
  }
  return (zero + num).slice(-digit)
}
